import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
} from "@mui/material";

const CoreSelectObjArr = ({
  items = [],
  helperText,
  className,
  isFull,
  ...props
}) => {
  const itemList = items.map((item) => (
    <MenuItem key={item.value} value={item.value}>
      {item.label}
    </MenuItem>
  ));

  const boxClass = isFull ? "w-full" : className;
  const boxSx = { minWidth: 120, width: props.width || "100%", height: "100%" };

  return (
    <Box className={boxClass} sx={boxSx}>
      <FormControl
        fullWidth
        size="small"
        disabled={props.disabled}
        error={props.error}
        required={props.required}
      >
        <InputLabel>{props.label}</InputLabel>
        <Select
          {...props}
          MenuProps={{
            disableScrollLock: true,
          }}
        >
          {itemList}
        </Select>
        <FormHelperText>{props.error ? helperText : ""}</FormHelperText>
      </FormControl>
    </Box>
  );
};

export default CoreSelectObjArr;
